import apiClient from 'utilities/apiClient';

export const get_products = (url, payload) => {
  return apiClient.get(
    `${apiClient.Urls.productDetails}/${url}`,
    payload,
    true
  );
};

export const createProduct = (url, payload) => {
  return apiClient.post(
    `${apiClient.Urls.productDetails}/${url}`,
    payload,
    true
  );
};

export const deleteProductId = (url, payload) => {
  return apiClient.post(
    `${apiClient.Urls.productDetails}/${url}`,
    payload,
    true
  );
};

export const downloadLabels = (url, payload) => {
  return apiClient.get(
    `${apiClient.Urls.productDetails}/${url}`,
    payload,
    true
  );
};

export const verifybatchId = (url, payload) => {
  return apiClient.post(
    `${apiClient.Urls.productDetails}/${url}`,
    payload,
    true
  );
};

export const getUsedLotNumbers = (url, payload) => {
  return apiClient.get(
    `${apiClient.Urls.productDetails}/${url}`,
    payload,
    true
  );
};

export const updateProdDispenseHeaderApi = (url, payload) => {
  return apiClient.post(
    `${apiClient.Urls.productDetails}/${url}`,
    payload,
    true
  );
};

export const regenerateProdLabelPdfApi = (url, payload) => {
  return apiClient.get(
    `${apiClient.Urls.productDetails}/${url}`,
    payload,
    true
  );
};

export const updateProdLabelWeightsApi = (url, payload) => {
  return apiClient.post(
    `${apiClient.Urls.productDetails}/${url}`,
    payload,
    true
  );
};

export const createMiscellaneous = (url, payload) => {
  return apiClient.post(
    `${apiClient.Urls.miscellaneous}/${url}`,
    payload,
    true
  );
};

export const get_Miscellaneous = (url, payload) => {
  return apiClient.get(`${apiClient.Urls.miscellaneous}/${url}`, payload, true);
};
